import { countBy } from "lodash";
import validate from "validate.js";
import type { AllConfigurationVariables } from "../../ConfigurationVariable";
import { ValidJavascriptIdentifier } from "../../EditValidations";
import { UnavailableEnvironmentIndexError } from "../../IndexEntry";
import type { AnyEnvironmentIndex } from "../../getEnvironmentIndex";
import { getEnvironmentIndex } from "../../getEnvironmentIndex";
import { RichString } from "../../RichString";
import { WorkspacePageType } from "../../WorkspacePageType";
import { createProblemFinder } from "../createProblemFinder";
import { ProblemSeverity } from "../ProblemSeverity";

validate.validators.uniqueConfigurationVariableApiIdentifier = (_value: string, options: Record<string, any>, _key: any, node: any) => {
  let index: AnyEnvironmentIndex;
  try {
    index = getEnvironmentIndex(node);
  } catch (e) {
    if (e instanceof UnavailableEnvironmentIndexError) {
      // don't validate uniqueness when the environment index is unavailable
      return;
    } else {
      throw e;
    }
  }

  if (!node.apiIdentifier) {
    return;
  }

  const valueCounts = countBy(
    index.configurationVariablesWithoutProblems.map((configurationVariable) => configurationVariable.apiIdentifier)
  );
  if (valueCounts[node.apiIdentifier] > 1) {
    return options.message;
  }
};

export const ConfigurationVariableProblems = createProblemFinder<AllConfigurationVariables>(
  {
    apiIdentifier: {
      format: {
        pattern: ValidJavascriptIdentifier,
        message: (value: string) =>
          value
            ? `^Environment variable ${RichString.text(value)} must be a valid js identifier`
            : `^Environment variable must have a name`,
        inContextMessage: (value: string) => (value ? "must be a valid js identifier" : "must have a name"),
        severity: ProblemSeverity.Error,
      },
      uniqueConfigurationVariableApiIdentifier: {
        message: (value: string) => `^Environment variable ${RichString.text(value)} must be unique`,
        inContextMessage: "must be unique",
        severity: ProblemSeverity.Error,
      },
    },
  },
  { name: "Configuration Variable", tabType: WorkspacePageType.ConfigurationVariablesIndex }
);
